import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { Fade, makeStyles } from '@material-ui/core';
import Note from './note';
import { prepareNotificationUpdates } from '../../../utility/globalNotifications';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'block',
    width: '100%',
  },
  noteWrapper: {
    marginBottom: spacing(4),
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
}));

const NotesList = ({
  translations,
  currentUser = null,
  canAccessUserProfileCheck = () => {},
  notes,
  notifications = null,
  scrollToNoteId = 0,
  isPrivateOnly = false,
  checkCanManageNote = () => true,
  checkIsDisabledEdit = () => false,
  checkCanManageTask = () => {},
  goToUserProfile = () => {},
  onTaskStatusChange = () => {},
  onEdit,
  onDelete,
  onClearNotifications = () => {},
}) => {
  const classes = useStyles();
  const notificationsData = useMemo(() => {
    if (notifications) {
      return prepareNotificationUpdates(
        translations.notifications.updates,
        notifications.model,
        notifications.updates
      );
    }

    return null;
  }, [translations, notifications]);

  return (
    <TransitionGroup className={classes.root}>
      {notes.map(note => {
        const isCreatedByMe = note?.creator?.id === currentUser?.id;

        return (
          <Fade
            key={`note_${note.id}`}
            className={classes.noteWrapper}
            in
            unmountOnExit
          >
            <div>
              <Note
                translations={translations}
                note={note}
                notifications={notificationsData}
                shouldScrollInToView={scrollToNoteId === note.id}
                hasNotifications={notifications?.objectId === note.id}
                isNotificationUpdate={!!notifications?.isUpdate}
                isCreatedByMe={isCreatedByMe}
                isPrivateOnly={isPrivateOnly}
                checkCanManageNote={checkCanManageNote}
                checkIsDisabledEdit={checkIsDisabledEdit}
                canAccessUserProfileCheck={canAccessUserProfileCheck}
                checkCanManageTask={checkCanManageTask}
                goToUserProfile={goToUserProfile}
                onTaskStatusChange={onTaskStatusChange}
                onEdit={onEdit}
                onDelete={onDelete}
                onClearNotifications={onClearNotifications}
              />
            </div>
          </Fade>
        );
      })}
    </TransitionGroup>
  );
};

NotesList.propTypes = {
  translations: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  notes: PropTypes.arrayOf(PropTypes.object).isRequired,
  notifications: PropTypes.object,
  isPrivateOnly: PropTypes.bool,
  scrollToNoteId: PropTypes.number,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  checkCanManageNote: PropTypes.func,
  checkCanManageTask: PropTypes.func,
  checkIsDisabledEdit: PropTypes.func,
  onTaskStatusChange: PropTypes.func,
  canAccessUserProfileCheck: PropTypes.func,
  goToUserProfile: PropTypes.func,
  onClearNotifications: PropTypes.func,
};

export default NotesList;
